export function Chips({ options, value, onChange, testid }) {
  return (
    <div className="mt-2 flex flex-wrap gap-2" data-testid={testid}>
      {options.map((o) => {
        const v = typeof o === "string" ? o : o.value;
        const label = typeof o === "string" ? o : o.label;
        const active = value === v;
        return (
          <button
            key={v}
            type="button"
            onClick={() => onChange(active ? null : v)}
            data-testid={`${testid}-${v}`.replace(/\s+/g, "-").toLowerCase()}
            className={`rounded-full border px-3.5 py-2 text-sm transition-colors ${active ? "border-[#D4AF37] bg-[#D4AF37]/15 text-[#F4F4F5]" : "border-[#27272A] bg-[#0D0D0F] text-[#B4B4BC] hover:border-[#3F3F46]"}`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export const WHEN = ["Entro mezzogiorno", "Nel pomeriggio", "In serata"];
export const HELPED = ["Averla programmata", "Farla subito", "La versione minima", "Un ambiente tranquillo", "Il sostegno di qualcuno"];
export const DIFFICULTY = ["Poco tempo", "Un imprevisto", "Stanchezza", "Mi è passato di mente", "Non era il momento giusto"];

export function Field({ label, children }) {
  return (
    <div className="mt-4">
      <p className="text-[12px] font-semibold uppercase tracking-wider text-[#D4AF37]">{label}</p>
      {children}
    </div>
  );
}

export const inputCls = "mt-2 w-full rounded-xl border border-[#27272A] bg-[#09090B] p-3 text-base text-[#F4F4F5] outline-none placeholder:text-[#8A8E96] focus:border-[#D4AF37]/50";
